import api from "../axios";

class PaymentService {
  /**
   * Gets UUID for a new payment
   * @returns {Promise<string>} Payment UUID
   */
  async getPaymentUUID(debug = false) {
    if (debug === true) {
      return "123";
    }

    try {
      const response = await api.get("/payments/get_uuid");
      // console.log(response);
      return response.uuid;
    } catch (error) {
      console.error("Error getting payment UUID:", error);
      throw error;
    }
  }

  /**
   * Checks payment status by UUID
   * @param {string} uuid - Payment UUID to check
   * @returns {Promise<Object>} Payment status information
   */
  async checkPaymentStatus(uuid) {
    if (!uuid) {
      throw new Error("Payment UUID not provided");
    }

    try {
      const response = await api.get(`/payments/check_uuid/${uuid}`);
      // console.log(response);
      return response;
    } catch (error) {
      console.error("Error checking payment status:", error);
      throw error;
    }
  }
}

export const paymentService = new PaymentService();
